import { initDoorAnimation, updateTextDoorState } from "../../../doorAnimationStore";
import { DEFAULT_Y_POS } from "../../constants";
import { toggleSceneObject } from "../../togglers";

const NAME_SIDE_MAPPING = Object.freeze({
    left: "levaya",
    right: "pravaya",
});

function changeDoor({ side, enabled }) {
    const { tempName: wardrobeType, tableSize, allWardrobeDoors, activeWardrobeDoors } = servObj;

    const { tableWidth, tableDepth, tableHeight } = tableSize;

    const width = tableWidth.current;
    const depth = tableDepth.current;
    const height = tableHeight.current;

    const name = buildDoorName({
        side,
        wardrobeType,
        width,
        height,
        depth,
    });

    const userData = buildUserData({
        side,
        name,
        width,
        height,
        depth,
    });

    const newDoor = toggleSceneObject({
        allObjects: allWardrobeDoors,
        activeArray: activeWardrobeDoors,
        name,
        isChecked: enabled,
        position: { y: DEFAULT_Y_POS },
        userData,
        filterActiveFn: createFilterFn({ side, height }),
    });

    if (newDoor) initDoorAnimation(newDoor);

    const animateDoorsBtn = document.getElementById("animate-doors");
    updateTextDoorState(animateDoorsBtn);
}

function buildDoorName({ side, wardrobeType, width, height, depth }) {
    const nameSide = NAME_SIDE_MAPPING[side];
    const isInstrumentalny = wardrobeType === "instrumentalniy";

    if (isInstrumentalny) wardrobeType = "shio";

    return `${nameSide}_petlya__shkaf__${wardrobeType}__${height}x${width}x${depth}`;
}

function buildUserData({ side, name, width, height, depth }) {
    return {
        doorSide: side,
        name,
        isAnimate: true,
        sizes: { width, height, depth },
    };
}

function createFilterFn({ side, height }) {
    return (el) => {
        const { doorSide, sizes } = el.userData ?? {};

        if (doorSide === side) return false;
        if (sizes?.height !== height) return false;

        return true;
    };
}

// Public API
export function changeDoors(enabled) {
    changeDoor({ side: "left", enabled });
    changeDoor({ side: "right", enabled });
}
